<template>
  <div class="container-locacoes">

    <div class="row">
      <div class="col-sm-12">
        <h2 class="d-none d-sm-block">Lista de Locações</h2>
        <h4 class="d-block d-sm-none">Lista de Locações</h4><br>
      </div>

      <router-link v-if="getPermissao() == 1" to="/locacao" class="col-sm-3 btn btn-warning">+ Criar Nova</router-link>
 <!-- Botão Voltar -->
      <button class="btn btn-secondary btn-sm ml-1" @click="$router.go(-1)">
        Voltar
      </button>
      <div class="col-sm-12"><br></div>

      <!-- FORM DE BUSCA -->
      <form class="row" method="POST" ref="formularioBusca" @submit.prevent.stop="buscar">

        <div class="form-group col-sm-3">
          <label>Período:</label>
          <Datepicker @reset="resetarData" show-clear-button placeholder="De - Até" range v-model="selectedDate" lang="pt-br" date-format="formato"/>
        </div>

         <div class="form-group col-sm-3">
          <label>Pasta:</label>
          <input type="text" class="form-control" v-model="pasta" placeholder="">
        </div>

        <div class="form-group col-sm-3">
          <label>Referência:</label>
          <input type="text" class="form-control" v-model="referencia" placeholder="Imóvel / Referência">
        </div>

        <div class="form-group col-sm-3">
          <label>Locador:</label>
          <input type="text" class="form-control" v-model="locadorNome">
        </div>

        <div class="form-group col-sm-3">
          <label>Locatário:</label>
          <input type="text" class="form-control" v-model="locatarioNome">
        </div>

        <div class="form-group col-sm-3">
        <label>Garantia:</label>
        <select class="form-control" name="garantia" v-model="garantia">
          <option value="">Nenhuma</option>
          <option value="Fiador">Fiador</option>
          <option value="Titulo">Titulo</option>
          <option value="Seguro">Seguro</option>
          <option value="Caução">Caução</option>
        </select>
      </div>

        <button ref="buscar" type="submit" class="btn btn-warning col-sm" style="max-height:40px;margin-top:30px;">BUSCAR</button>
        <button class="btn btn-danger col-sm ml-1" @click="limpar" type="button" style="max-height:40px;margin-top:30px;">LIMPAR</button>
      </form>
<p>Vencimentos:</p>
         <button @click="buscar(10)" class=" btn btn-sm  btn-info d-sm-block ml-1">Até dia 10</button> 
           <button @click="buscar(20)" class=" btn btn-sm  btn-warning d-sm-block ml-1">Dia 11 - 20</button> 
             <button @click="buscar(30)" class=" btn btn-sm  btn-success d-sm-block ml-1">Dia 21 - 30</button> 
             <router-link :to="`/relatorioBoletos`" class=" btn  btn-primary d-sm-block ml-1">Visualizar Boletos</router-link>
    </div>

    <div class="row">
      <div class="col-12"><br></div>
    </div>

    <!-- TABELA -->
    <div class="row">
      <div class="col-sm-2" v-if="loading">
        <div class="spinner-border" role="status" style="max-height:40px;margin-top:35px;">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div class="table-responsive">
        <table class="col-sm table">
          <thead>
            <tr>
              <th>Pasta</th>
              <th>Referência</th>
              <th>Locador</th>
              <th>Locatário</th>
              <th>Início</th>
              <th>Aluguel</th>
             
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in locacoes" :key="item.LOC_ID">
              <td>{{item.LOC_PASTA}}</td>
              <td>{{item.LOC_IMOVEL}}</td>
              <td>{{item.LOC_LOCADOR}}</td>
              <td>{{item.LOC_LOCATARIO}}</td>
              <td>{{item.LOC_INICIO_CONTRATO}}</td>
              <td>R$ {{item.LOC_ALUGUEL}}</td>
             
              <td>
                <router-link :to="'/locacao/' + item.LOC_PASTA" class="btn btn-sm btn-info">VER</router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-sm-4 offset-sm-4">
        <button @click="paginar" ref="paginar" type="submit" class="btn btn-warning col-sm" style="max-height:40px;margin-top:10px;">MAIS RESULTADOS</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'BuscaLocacoes',

  data(){
    return {
      garantia:'',
      locacoes: [],
      loading: false,
      referencia: '',
      locadorNome: '',
      locatarioNome: '',
      pasta: '',
      selectedDate: [],
      formato:{day: '2-digit',month: '2-digit',year: 'numeric' }
    }
  },

  methods:{
    getUsuario(){
      return sessionStorage.getItem('imobiliariaNome');
    },
    getPermissao(){
      return sessionStorage.getItem('imobiliaria');
    },
    resetarData(){
      this.selectedDate = [];
    },
    limpar(){
      this.referencia = '';
      this.locadorNome = '';
      this.locatarioNome = '';
      this.pasta = '';
      this.selectedDate = [];
    },

    get(){
      let fm = new FormData();
      fm.append('permissao', this.getPermissao());
      fm.append('corretor', this.getUsuario());
      fm.append('paginacao', 0);

      this.loading = true;
      axios
        .post('https://www2.royaljardim.com.br/sistema/locacao/getLocacoes', fm)
        .then(response => this.locacoes = response.data)
        .catch(err => console.log(err))
        .finally(() => this.loading = false);
    },

    buscar(vencimento = null){
      this.loading = true;
      let fm = new FormData(this.$refs["formulario"]);
      fm.append('permissao', this.getPermissao());
      fm.append('corretor', this.getUsuario());
      fm.append('paginacao', 0);
        fm.append('pasta', this.pasta);
        fm.append('locadorNome', this.locadorNome);
        fm.append('locatarioNome', this.locatarioNome);
           fm.append('referencia', this.referencia);
            fm.append('garantia', this.garantia);

            if(vencimento){
              fm.append('vencimento', vencimento);
            }

      // filtro de data
      if(this.selectedDate.length > 0){
        let dd = this.selectedDate[0].toISOString().split("T")[0];
        let dd2 = this.selectedDate[1].toISOString().split("T")[0];
        fm.append('de', dd + " 00:00");
        fm.append('ate', dd2 + " 23:59");
      }

      axios
        .post('https://www2.royaljardim.com.br/sistema/locacao/busca', fm)
        .then(response => {this.locacoes = response.data;console.log(response.data)})
        .catch(err => console.log(err))
        .finally(() => this.loading = false);
    },

    paginar(){
      this.loading = true;
      let fm = new FormData(this.$refs["formulario"]);
      fm.append('permissao', this.getPermissao());
      fm.append('corretor', this.getUsuario());
      fm.append('paginacao', this.locacoes.length);
      fm.append('pasta', this.pasta);
        fm.append('locadorNome', this.locadorNome);
        fm.append('locatarioNome', this.locatarioNome);
           fm.append('referencia', this.referencia);

      axios
        .post('https://www2.royaljardim.com.br/sistema/locacao/busca', fm)
        .then(response => response.data.forEach(l => this.locacoes.push(l)))
        .catch(err => console.log(err))
        .finally(() => this.loading = false);
    }
  },

  mounted(){
    this.get();
  }
}
</script>